import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {logoutAuthAsync} from './store/actions';

const Logout: React.FC = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logoutAuthAsync.request());
  }, []);

  return <div>{t('autenticacao.desconectando')}</div>;
};

export default Logout;



// WEBPACK FOOTER //
// ./src/features/auth/Logout.tsx